<div class="dialog-content">
  <h2>Espace utilisateur</h2>
  <mat-divider></mat-divider>
  <form [formGroup]="espaceForm">
    <div class="nom-section">
      <label>Nom<span class="required-star">*</span> :</label>
      <mat-form-field appearance="outline">
        <mat-label>Nom</mat-label>
        <input formControlName="nom" matInput>
      </mat-form-field>
    </div>

    <div class="prenom-section">
      <label>Prénom<span class="required-star">*</span> :</label>
      <mat-form-field appearance="outline">
        <mat-label>Prénom</mat-label>
        <input formControlName="prenom" matInput>
      </mat-form-field>
    </div>


    <div class="contact-section">
      <label>Contact<span class="required-star">*</span> :</label>
      <div class="fields">
        <mat-form-field appearance="outline">
          <mat-label>Numéro de téléphone</mat-label>
          <input formControlName="mobilePhone" matInput>
          <mat-icon matPrefix>smartphone</mat-icon>
          @if (espaceForm.get('mobilePhone')?.touched && espaceForm.get('mobilePhone')?.hasError('pattern')) {
            <mat-error>
              Veuillez saisir un numéro de téléphone valide.
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Adresse E-mail</mat-label>
          <input formControlName="email" matInput type="email">
          <mat-icon matPrefix>mail</mat-icon>
        </mat-form-field>
      </div>
    </div>
    @if (isUserExterne) {
      <div class="password-section">
        <a href={{urlModifierMotDePasse}}>
          MODIFIER MOT DE PASSE
        </a>
      </div>
    }

    <mat-divider></mat-divider>
    <div class="message-required">
      <p>Les champs suivis d'un <span class="required-star">*</span> sont obligatoires.</p>
    </div>

    <div class="actions">
      <div class="align">
        <button (click)="onClose()" mat-raised-button>ANNULER</button>
        <button (click)="onSubmit()" [disabled]="espaceForm.pristine" class="button-validate" mat-raised-button>
          Enregistrer
        </button>
      </div>
    </div>
  </form>
</div>
